/**
 * ValfrihetAdBlock
 */
import React from 'react';
import { Link as LinkBase } from 'ui-component-library/base';
/** Main description for this component. */
var ValfrihetAdBlock = function (_a) {
    var url = _a.url, updated = _a.updated, heading = _a.heading, regionName = _a.regionName, excerpt = _a.excerpt, _b = _a.LinkComponent, LinkComponent = _b === void 0 ? LinkBase : _b, businessAreas = _a.businessAreas;
    var Link = LinkComponent;
    return (React.createElement(Link, { to: url, "data-cid": "AdSearchResult" },
        React.createElement("div", { className: "bg-white border px-10 pt-6 pb-10 rounded-md shadow-ad" },
            updated && React.createElement("p", { className: "text-greyDarker leading-6" }, updated),
            React.createElement("h2", { className: "mt-2 mb-4 text-teal leading-snug" }, heading),
            regionName && (React.createElement("p", { className: "font-semibold text-black leading-6 pb-1 pt-2" }, regionName)),
            excerpt && (React.createElement("p", { className: "text-black leading-6 break-words" }, excerpt.length > 136 ? (excerpt === null || excerpt === void 0 ? void 0 : excerpt.slice(0, 136)) + '...' : excerpt)),
            businessAreas && (React.createElement("p", { className: "font-semibold mt-6 text-black leading-6" }, businessAreas)))));
};
export default ValfrihetAdBlock;
